import React, { useState, useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { MdSettings, MdVisibility, MdTrendingUp, MdSwapHoriz, MdEdit } from 'react-icons/md';

const OfficerActionsDropdown = ({ officer, onView, onPerformance, onReassign, onEdit }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [dropdownPosition, setDropdownPosition] = useState('bottom');
  const [dropdownStyle, setDropdownStyle] = useState({});
  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);
  const dropdownMenuRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);



  const handleAction = (action) => {

    setIsOpen(false);
    switch (action) {
      case 'view':

        onView && onView(officer);
        break;
      case 'performance':

        onPerformance && onPerformance(officer);
        break;
      case 'reassign':

        onReassign && onReassign(officer);
        break;
      case 'edit':

        onEdit && onEdit(officer);
        break;
      default:
        console.log('Unknown action:', action);
        break;
    }
  };

  const handleToggleDropdown = () => {
    if (!isOpen) {
      setDropdownPosition('top');
      if (buttonRef.current) {
        const rect = buttonRef.current.getBoundingClientRect();
        setDropdownStyle({
          position: 'fixed',
          top: rect.top - 150 - 4 + window.scrollY, // 150 is dropdown height, 4 is margin
          left: rect.left + window.scrollX,
          zIndex: 999999,
          minWidth: 180,
          backgroundColor: 'white',
          border: '1px solid #e0e0e0',
          borderRadius: 8,
          boxShadow: '0 8px 24px rgba(0, 0, 0, 0.2)',
          overflow: 'hidden',
          pointerEvents: 'auto',
        });
      }
    }
    setIsOpen(!isOpen);
  };

  return (
    <>
      {/* Backdrop */}
      {isOpen && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          backgroundColor: 'rgba(0, 0, 0, 0.1)',
          zIndex: 99997,
        }} />
      )}

      <div style={{
        position: 'relative',
        zIndex: isOpen ? 99999 : 'auto'
      }} ref={dropdownRef}>
      {/* Settings Button */}
      <button
        ref={buttonRef}
        onClick={handleToggleDropdown}
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          padding: 8,
          borderRadius: 4,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: isOpen ? '#f0f0f0' : 'transparent',
          transition: 'background-color 0.2s',
        }}
        onMouseEnter={(e) => {
          if (!isOpen) e.target.style.backgroundColor = '#f8f9fa';
        }}
        onMouseLeave={(e) => {
          if (!isOpen) e.target.style.backgroundColor = 'transparent';
        }}
      >
        <MdSettings size={18} style={{ color: '#666' }} />
      </button>

      {/* Dropdown Menu */}
      {isOpen && (
        <div style={dropdownStyle} ref={dropdownRef}>
          {/* View Option */}
          <button
            onClick={() => handleAction('view')}
            style={{
              width: '100%',
              padding: '12px 16px',
              border: 'none',
              backgroundColor: 'transparent',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: 12,
              fontSize: 14,
              color: '#333',
              textAlign: 'left',
              transition: 'background-color 0.2s',
              pointerEvents: 'auto',
            }}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#f8f9fa'}
            onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
          >
            <MdVisibility size={16} style={{ color: '#1976d2' }} />
            View Details
          </button>

          {/* Performance Option */}
          <button
            onClick={() => handleAction('performance')}
            style={{
              width: '100%',
              padding: '12px 16px',
              border: 'none',
              backgroundColor: 'transparent',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: 12,
              fontSize: 14,
              color: '#333',
              textAlign: 'left',
              transition: 'background-color 0.2s',
              pointerEvents: 'auto',
            }}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#f8f9fa'}
            onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
          >
            <MdTrendingUp size={16} style={{ color: '#28a745' }} />
            Performance
          </button>

          {/* Edit Option */}
          <button
            onClick={() => handleAction('edit')}
            style={{
              width: '100%',
              padding: '12px 16px',
              border: 'none',
              backgroundColor: 'transparent',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: 12,
              fontSize: 14,
              color: '#333',
              textAlign: 'left',
              transition: 'background-color 0.2s',
              borderTop: '1px solid #f0f0f0',
              pointerEvents: 'auto',
            }}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#f8f9fa'}
            onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
          >
            <MdEdit size={16} style={{ color: '#007bff' }} />
            Edit
          </button>

          {/* Reassign Option */}
          <button
            onClick={() => handleAction('reassign')}
            style={{
              width: '100%',
              padding: '12px 16px',
              border: 'none',
              backgroundColor: 'transparent',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: 12,
              fontSize: 14,
              color: '#333',
              textAlign: 'left',
              transition: 'background-color 0.2s',
              borderTop: '1px solid #f0f0f0',
              pointerEvents: 'auto',
            }}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#f8f9fa'}
            onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
          >
            <MdSwapHoriz size={16} style={{ color: '#ff9800' }} />
            Reassign
          </button>
        </div>
      )}
      </div>
    </>
  );
};

export default OfficerActionsDropdown;
